import { render, staticRenderFns } from "./UserLogs.vue?vue&type=template&id=2bf22aca&scoped=true&"
import script from "./UserLogs.vue?vue&type=script&lang=ts&"
export * from "./UserLogs.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./UserLogs.vue?vue&type=style&index=1&id=2bf22aca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf22aca",
  null
  
)

export default component.exports